(function() {
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(init);
  } else {
    setTimeout(init, 100);
  }
  function init() {
    const reveals = document.querySelectorAll('[data-landing-section] .reveal');
    const ro = new IntersectionObserver(function(entries) {
      entries.forEach(function(e, i) {
        if (e.isIntersecting) {
          setTimeout(function() { e.target.classList.add('visible'); }, i * 50);
          ro.unobserve(e.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -30px 0px' });
    reveals.forEach(function(r) { ro.observe(r); });
  }
})();
